import React, { useState } from 'react';
import { Input } from './Input';
import { Button } from './Button';
interface GuestSettingsProps {
  onSave: (settings: {
    ownGuests: number;
    additionalSpots: number;
    maleSpots: number;
    femaleSpots: number;
    anySpots: number;
    costSharing: 'split' | 'host';
  }) => void;
}
export const GuestSettings = ({
  onSave
}: GuestSettingsProps) => {
  const [ownGuests, setOwnGuests] = useState(0);
  const [additionalSpots, setAdditionalSpots] = useState(0);
  const [maleSpots, setMaleSpots] = useState(0);
  const [femaleSpots, setFemaleSpots] = useState(0);
  const [anySpots, setAnySpots] = useState(0);
  const [costSharing, setCostSharing] = useState<'split' | 'host'>('split');
  const handleSave = () => {
    onSave({
      ownGuests,
      additionalSpots,
      maleSpots,
      femaleSpots,
      anySpots,
      costSharing
    });
  };
  return <div className="p-4 border border-dashed border-gray-300 rounded-lg" data-id="element-63">
      <h3 className="text-lg font-medium text-gray-800 mb-4" data-id="element-64">Guest Settings</h3>
      <div className="mb-4" data-id="element-65">
        <Input label="How many friends are you bringing?" type="number" value={ownGuests.toString()} onChange={e => setOwnGuests(parseInt(e.target.value) || 0)} data-id="element-66" />
      </div>
      <div className="mb-4" data-id="element-67">
        <Input label="Additional spots for others" type="number" value={additionalSpots.toString()} onChange={e => setAdditionalSpots(parseInt(e.target.value) || 0)} data-id="element-68" />
      </div>
      {additionalSpots > 0 && <>
          <div className="p-3 bg-gray-100 rounded-md mb-4" data-id="element-69">
            <h4 className="font-medium text-gray-700 mb-2" data-id="element-70">
              Gender distribution
            </h4>
            <div className="grid grid-cols-3 gap-2" data-id="element-71">
              <div data-id="element-72">
                <Input label="Male" type="number" value={maleSpots.toString()} onChange={e => setMaleSpots(parseInt(e.target.value) || 0)} data-id="element-73" />
              </div>
              <div data-id="element-74">
                <Input label="Female" type="number" value={femaleSpots.toString()} onChange={e => setFemaleSpots(parseInt(e.target.value) || 0)} data-id="element-75" />
              </div>
              <div data-id="element-76">
                <Input label="Any" type="number" value={anySpots.toString()} onChange={e => setAnySpots(parseInt(e.target.value) || 0)} data-id="element-77" />
              </div>
            </div>
          </div>
          <div className="mb-4" data-id="element-78">
            <h4 className="font-medium text-gray-700 mb-2" data-id="element-79">Cost sharing</h4>
            <div className="flex gap-4" data-id="element-80">
              <div className={`border rounded-md p-3 flex-1 cursor-pointer ${costSharing === 'split' ? 'border-gray-800 bg-gray-100' : 'border-gray-300'}`} onClick={() => setCostSharing('split')} data-id="element-81">
                <h5 className="font-medium" data-id="element-82">Split costs</h5>
                <p className="text-sm text-gray-600" data-id="element-83">
                  Everyone pays their share
                </p>
              </div>
              <div className={`border rounded-md p-3 flex-1 cursor-pointer ${costSharing === 'host' ? 'border-gray-800 bg-gray-100' : 'border-gray-300'}`} onClick={() => setCostSharing('host')} data-id="element-84">
                <h5 className="font-medium" data-id="element-85">You host</h5>
                <p className="text-sm text-gray-600" data-id="element-86">You pay for everyone</p>
              </div>
            </div>
          </div>
        </>}
      <Button onClick={handleSave} className="w-full" data-id="element-87">
        Save Settings
      </Button>
    </div>;
};